module.exports = __webpack_public_path__ + "static/img/41.52c9ecb0.png";